import * as React from "react";
import { useDispatch } from "@teamprevent/admin-redux";

import { AnsweredQuestionWithId } from "@teamprevent/common/model";
import { navigateToParentRoute } from "@teamprevent/common/routing/actions";

import { ClinicalNotes } from "../../../clinicalNotes/components/ClinicalNotes";
import { submitHealthSurveillanceClinicalNotes, saveHealthSurveillanceClinicalNotes } from "../actions";

import { HealthSurveillanceClinicalNotesSections } from "./HealthSurveillanceClinicalNotesSections";

const HealthSurveillanceClinicalNotes: React.FunctionComponent = () => {
    const dispatch = useDispatch();

    const save = React.useCallback((ohCaseId: string, taskId: string, customerId: string, answeredQuestions: AnsweredQuestionWithId[], eTag: string) =>
        dispatch(saveHealthSurveillanceClinicalNotes(customerId, ohCaseId, taskId, answeredQuestions, eTag)), [dispatch]);

    const submit = React.useCallback(async (ohCaseId: string, taskId: string, customerId: string) => {
        await dispatch(submitHealthSurveillanceClinicalNotes(customerId, ohCaseId, taskId));
        dispatch(navigateToParentRoute());
    }, [dispatch]);

    return (
        <ClinicalNotes saveQuestionnaire={save} submitQuestionnaire={submit}>
            <HealthSurveillanceClinicalNotesSections />
        </ClinicalNotes>
    );
};

export { HealthSurveillanceClinicalNotes };
